import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { getDisputeInformationFields } from '../../../../store/tables/admin/transactions-data';
import { useDisputesContext } from '../../../../store/disputes/disputes-context';
import { getFormattedUTCDate, numberFormatter } from '../../../../utils/utilities';
import { CopyComponent } from '../../../CopyComponent';
import { Title } from '../../../developers/page-components/Title';

export const DisputesQueueDetailsInformation: FC = () => {
	const { t } = useTranslation();
	const { disputesContextState: { disputeDetails }} = useDisputesContext();

	const getValueFields = (key, value, title): JSX.Element => {
		switch (key) {
			case 'createdOn':
			case 'authorizationDate':
			case 'requestDate':
				return (
					<div>
						{getFormattedUTCDate(value, 'yyyy-MM-dd HH:mm')}
					</div>
			);
			case 'amount': return (
				<>
					<div>
						<span className="fw-bolder">
							${numberFormatter(value)}{' '}
						</span>
						<span className="">
							{disputeDetails?.currency}
						</span>
					</div>
				</>
			);
			case 'cardBrand': return (
				<div className="d-flex align-items-center fs-7 flex-wrap">
					<div className="me-2">
						<span>{disputeDetails?.bin}</span>
						<span>******</span>
						<span>{disputeDetails?.last4}</span>
					</div>
					<span>{value}</span>
				</div>
			);
			case 'isWebhook': return (
				<>
					{value
						? <FontAwesomeIcon icon={faCircleCheck} width={16} className="text-danger h-20px"/>
						: '-'
					}
				</>
			);
			case 'invoiceNumber':
			case 'orderId':
			case 'externalReferenceID':
			case 'arn': return (
				<div className="d-flex align-items-center">
					<div className="me-2">{value ? value : '-'}</div>
					{value && <CopyComponent value={value} title={title}/>}
				</div>
			);
			default: return (
				<div>{value ? value : '-'}</div>
			);
		}
	};

	const getDisputeInfoField = (key, title, value): JSX.Element => (
		<div className="d-flex mt-2" key={key}>
			<div className="w-125px fs-7 fw-bolder">{title}:</div>
			<div className="fs-7">{getValueFields(key, value, title)}</div>
		</div>
	);

	const getSectionData = (): JSX.Element => {
		const data = getDisputeInformationFields(disputeDetails);
		return (
			<div>
				<div className="d-lg-none ">
					<div>{data?.map(({ key, title, value }) => getDisputeInfoField(key, title, value))}</div>
				</div>
				<div className="d-none d-lg-flex d-xl-none">
					{[1,2].map(el => (
						<div key={el} className="col-6">
							{data
								?.filter(item => item?.tablet === el)
								?.map(({ key, title, value }) => getDisputeInfoField(key, title, value))
							}
						</div>
					))}
				</div>
				<div className="d-none d-xl-flex">
					{[1,2,3].map(el => (
						<div key={el} className="col-4">
							{data
								?.filter(item => item?.desktop === el)
								?.map(({ key, title, value }) => getDisputeInfoField(key, title, value))
							}
						</div>
					))}
				</div>
			</div>
		);
	};

	return (
		<div className="card mb-6">
			<div className="card-body">
				<div className="mb-5">
					<Title title={t('DISPUTES.DISPUTE_INFO')} additionalClass="fs-2"/>
				</div>
				{getSectionData()}
			</div>
		</div>
	);
};
